export default __webpack_public_path__ + "static/media/sample-passport-data-page-bad.ef78cc2c.jpg";